<template>
  <div class="login">
    <el-row>
      <el-col :md="9" :sm="24"
        ><div class="login-form">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-position="top"
            label-width="120px"
            class="demo-ruleForm"
          >
            <div class="logo">
              <h1 style="color: rgb(0, 123, 255)">إدارة العقارات</h1>
              <!-- <el-row>
                <el-col :span="12" class="logoImg">
                  <img :src="require('../../images/logo2.png')" alt="" />
                </el-col>
              </el-row> -->
            </div>
            <el-form-item prop="name">
              <el-input
                suffix-icon="el-icon-user"
                type="text"
                placeholder="اسم المستخدم"
                autofocus
                @keyup.enter.native="$refs.password.focus()"
                v-model="ruleForm.name"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" class="password">
              <el-input
                type="password"
                placeholder=" كلمة المرور"
                ref="password"
                :show-password="true"
                suffix-icon="el-icon-lock"
                @keyup.enter.native="submitForm('ruleForm')"
                v-model="ruleForm.password"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item class="signIn">
              <el-button
                class="text-center"
                type="warning"
                @click="submitForm('ruleForm')"
                >تسجيل الدخول</el-button
              >
              <!-- <el-button @click="resetForm('ruleForm')">Reset</el-button> -->
            </el-form-item>
          </el-form>
        </div></el-col
      >
      <el-col :md="15" :sm="0" :xs="0" class="d-sm-none d-md-block">
        <div class="login-img"></div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import axiosApi from "@/plugins/axios.js";

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("من فضلك حدد كلمة المرور"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("من فضلك حدد اسم المستخدم"));
      } else {
        callback();
      }
    };
    return {
      true: true,
      ruleForm: {
        name: "",
        password: "",
      },
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],
        name: [{ validator: validateName, trigger: "blur" }],
      },
    };
  },
   created() {
    // this.getProjects();
 
  },
  methods: {
       getProjects() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get("/projects")
        .then((res) => {
          this.projects = res.data;
          this.allProjects = res.data;
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    login() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .post("auth/login", this.ruleForm)
        .then((res) => {
          localStorage.setItem("user", JSON.stringify(res.data.data));
          localStorage.setItem(
            "user_inventories",
            JSON.stringify(res.data.inventories)
          );
          localStorage.setItem("token", res.data.access_token);
          localStorage.setItem("menu", JSON.stringify(res.data.menu));
          localStorage.setItem(
            "permissionNames",
            JSON.stringify(res.data.permissionNames)
          );
          localStorage.setItem("branch", JSON.stringify(res.data.branch));
          console.log(res.data);
          // this.faturaLogin();
          this.$notify({
            title: `${res.data.data.name} مرحبا`,
            message: "تم الدخول إلى السيستم بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من بيانات المستخدم",
              duration: 1500,
            });
          } else {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من اتصال الانترنت",
              duration: 1500,
            });
          }
        })
        .finally(() => {
          loading.close();
          if (localStorage.getItem("token")) {
            this.$router.push("/projects");
          }
        });
    },
    faturaLogin() {
      axiosApi
        .post("fatura/login")
        .then((response) => {
          console.log(response);
          localStorage.setItem("fatura_token", response.data.fatura_token);
          location.reload();
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          if (localStorage.getItem("token")) {
            this.$router.push("/projects");
          }
          location.reload();
        });
    },
  },
};
</script>
<style lang="sass">
@import "../../styles/login.scss"
</style>
